import {setGroup, track} from '@amplitude/analytics-browser';

import {MetricUser, MetricContext, MetricData} from './types';

export const initMetrics = (user: MetricUser) => {
  const {orgId} = user;

  setGroup('orgId', orgId);
};

export const logMetricEvent = (
  name: string,
  context: MetricContext,
  data?: MetricData
) => {
  const {module, feature} = context;

  track(name, {...data, feature, module});
};
